<!-- InspectorDocument.vue -->
<template>
  <InspectorPDF
    v-if="documentType === 'pdf'"
    :pdf-url="documentUrl"
  />
  <InspectorImage
    v-else-if="documentType === 'image'"
    :image-url="previewUrl"
  />
  <div v-else
    class="unsupported-viewer">
    <div class="unsupported-content">
      <svg class="unsupported-icon"
        xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"></path>
        <polyline points="13 2 13 9 20 9"></polyline>
      </svg>
      <h3 class="unsupported-title">Preview Not Available</h3>
      <p class="unsupported-message">
        This file type ({{ documentType }}) cannot be previewed in the browser.
      </p>
      <a
        v-if="documentUrl"
        :href="documentUrl"
        download
        class="unsupported-download"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
          <polyline points="7 10 12 15 17 10"></polyline>
          <line x1="12" y1="15" x2="12" y2="3"></line>
        </svg>
        Download File
      </a>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import InspectorPDF from './InspectorPDF.vue';
import InspectorImage from './InspectorImage.vue';

const props = defineProps({
  documentUrl: {
    type: String,
    required: true,
  },
  previewUrl: {
    type: String,
    required: false,
  },
  fileType: {
    type: String, // pdf or image
    required: true,
  },
});


const documentType = computed(() => {
  const type = props.fileType.toLowerCase();
  if (type === 'pdf') return 'pdf';
  if (['png', 'jpg', 'jpeg', 'gif', 'webp'].includes(type)) return 'image';
  return type;
});
</script>
